import React from "react";
import "./Si2tLogo.css";

const Si2tLogo = ({ compact = false, inverse = false, className = "" }) => (
  <span
    className={`si2t-logo ${inverse ? "is-inverse" : ""} ${className}`}
    role="img"
    aria-label="SI²T — Bureau d'études techniques"
  >
    <img
      className="si2t-logo-mark"
      src={inverse ? "/brand/si2t-logo-inverse.svg" : "/brand/si2t-logo.svg"}
      width="596"
      height="220"
      alt=""
      aria-hidden="true"
    />
    {!compact && (
      <span className="si2t-logo-tag" aria-hidden="true">
        Bureau d'études
        <br />
        techniques
      </span>
    )}
  </span>
);

export default Si2tLogo;
